/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{glsl as o}from"../../core/shaderModules/glsl.js";const l=255;function c(c){c.code.add(o`
    vec3 quantizeGlobalIlluminationColor(vec3 color) {
      vec3 clampedColor = clamp(color, vec3(0.0), vec3(1.0));
      return floor(clampedColor * ${o.float(l)} + 0.5) * ${o.float(1/l)};
    }
  `)}export{c as GlobalIlluminationColorQuantization};
